import { createContext, type PropsWithChildren, useContext } from 'react'

export enum AssetOption {
  Peloton = 'peloton',
  Hyperice = 'hyperice',
  Oura = 'oura',
  EightSleep = 'eight-sleep',
  GrowTherapy = 'grow-therapy',
  Lyra = 'lyra',
  Function = 'function',
  HimsHers = 'hims-hers',
  Prenuvo = 'prenuvo',
  Sesame = 'sesame',
  Trx = 'trx',
}

export type EmployerRenewalAssetProviderProps = {
  assetPaths: Record<AssetOption, string>
}

type EmployerRenewalAssetContextType = {
  getAssetPath: (option: AssetOption) => string
}

const EmployerRenewalAssetContext = createContext<EmployerRenewalAssetContextType>({
  getAssetPath: (_option: AssetOption) => '',
})

export function useEmployerRenewalAsset () {
  return useContext(EmployerRenewalAssetContext)
}

export default function EmployerRenewalAssetProvider ({ assetPaths, children }: PropsWithChildren<EmployerRenewalAssetProviderProps>) {
  const getAssetPath = (option: AssetOption) => assetPaths[option]

  return (
    <EmployerRenewalAssetContext.Provider value={{ getAssetPath }}>
      {children}
    </EmployerRenewalAssetContext.Provider>
  )
}
